import React from 'react';

import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';

import { useAxios } from 'configs/requests';
import { Loading, Error } from 'components/Fetch';

import { InfoBox } from '.';

const AuthError = () => {
  const intl = useIntl();
  const { patientId } = useParams<{ surveyId: string; patientId: string }>();

  const [{ data, loading, error }, requestNewCode] = useAxios(
    {
      url: `/patient/Patient/${patientId}/requestNewCode`,
      method: 'POST'
    },
    { manual: true }
  );

  return (
    <>
      <InfoBox
        dataTestId="auth-error-box"
        title="questionnaireNotAccessibleKey"
        description={data ? 'newCodeSuccessKey' : 'newQuestionnaireLinkSentKey'}
        content={
          <>
            {loading && <Loading />}
            {!data && !loading && (
              <Button
                data-test="request-new-link-btn"
                className="align-self-center"
                variant="primary"
                onClick={() => requestNewCode()}
              >
                {intl.formatMessage({ id: 'requestNewLinkKey' })}
              </Button>
            )}
          </>
        }
      />
      {loading && <Loading />}
      {error && <Error />}
    </>
  );
};

export default AuthError;
